<template>
  <div class="filter-item">
    <div
      class="filter-item__header"
      :class="{ hide: !isCriteriaOpen }"
      @click="activeFilter"
    >
      <p class="filter-item__title">
        {{ getLocalizedName(compilations.name) }}
      </p>
      <div class="filter-item__arrow">
        <img src="~/assets/icons/arrow-down.svg" alt="open filters" />
      </div>
    </div>
    <div class="filter-item__body" :class="{ active: isShowAllValues }">
      <CheckboxCompilation
        v-for="category in compilations.categories"
        :category="category"
        :current-category-slug="route.params.categorySlug"
      >
        {{ getLocalizedName(category.compilation.self) }}
      </CheckboxCompilation>
      <ShowAll
        v-if="compilations.categories.length > 6"
        @click="showAllValues"
      />
    </div>
  </div>
</template>

<script setup>
import CheckboxCompilation from "~/modules/productCatalog/ui/components/filter/bar/CheckboxCompilation.vue";
import ShowAll from "~/modules/shared/buttons/ShowAll.vue";

const props = defineProps({
  compilations: { type: Object, required: true },
});

const route = useRoute();
const isCriteriaOpen = ref(true);
const isShowAllValues = ref(false);

function activeFilter() {
  isCriteriaOpen.value = !isCriteriaOpen.value;
}

function showAllValues() {
  isShowAllValues.value = !isShowAllValues.value;
}
</script>

<style lang="scss" scoped>
.filter-item {
  border-bottom: 1px solid var(--color-sky-base);

  padding: 8px 0;

  &:last-child {
    border: none;

    padding-bottom: 0;
  }

  @include bigMobile {
    background-color: var(--color-sky-lightest);
    border: none;
    border-radius: 16px;
  }

  &__header {
    @include flex-container(row, space-between, flex-start);

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    padding: 0 8px;
    margin-bottom: 8px;

    cursor: pointer;

    &.hide {
      margin-bottom: 0;

      & > .filter-item__arrow {
        transform: rotateZ(0deg);
      }

      & + .filter-item__body {
        height: 0;
      }
    }
  }

  &__title {
    @include bigMobile {
      @include font(14, 20);
    }
  }

  &__arrow {
    flex: 0 0 auto;

    transform: rotateZ(180deg);

    transition: transform 0.2s ease-in-out;
  }

  &__body {
    @include flex-container(column, flex-start);

    height: auto;

    overflow: hidden;

    &:not(.active) {
      .filter-checkbox__compilation {
        &:nth-child(n + 6) {
          display: none;
        }
      }
    }
  }
}
</style>
